import { styled } from '@linaria/react';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100vh - 56px);
  position: relative;
  padding: 16px;
  overflow-y: auto;
`;
